import React, { Component } from 'react';
import _ from 'lodash/fp';
import Button from 'components/button';
import SelectContent from 'components/select-content';
import enhance from './enhance';
import './schedule-default.css';

class ScheduleDefault extends Component {
  componentDidMount() {
    this.props.listen();
    this.props.selectContentId(this.props.defaultContentId);
  }

  componentWillUnmount() {
    this.props.stopListening();
  }

  render() {
    return (
      <div className="schedule-default">
        <div className="sub-heading">
          SELECT DEFAULT CONTENT
        </div>
        <SelectContent
          selectContentId={this.props.selectContentId}
          selectNextContentId={this.props.selectNextContentId}
          selectPrevContentId={this.props.selectPrevContentId}
          selectedContentId={this.props.selectedContentId}
          check={!this.props.canUpdate}
        />
        <Button
          disabled={!this.props.canUpdate}
          onClick={this.props.updateDefaultContentId}
        >
          Set default
        </Button>
      </div>
    );
  }
}

export default enhance(ScheduleDefault);



// WEBPACK FOOTER //
// ./src/components/schedule-default/index.js